import {
  FETCH_ITEM_LOCATION_LISTING_SUCCESS,
  FETCH_ITEM_LOCATION_LISTING_FAILURE,
  RESET,
} from "./itemLocationTypes";

const initialState = {
  allItemLocations: [],
  error: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ITEM_LOCATION_LISTING_SUCCESS:
      return {
        allItemLocations: action.payload,
        error: null,
      };
    case FETCH_ITEM_LOCATION_LISTING_FAILURE:
      return {
        allItemLocations: [],
        error: action.payload,
      };
    case RESET: {
      return initialState;
    }
    default:
      return state;
  }
};

export default reducer;
